import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;


const getPlanningList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/planning/', {
        headers: authHeader(), params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getPlanningListByField = (pressID, page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/planning/get/', {
        headers: authHeader(), params: {
            press: pressID,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const getPriorityList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/planning/get-priority-items/', {
        headers: authHeader(),
        params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        },
    });
};

const removePriority = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/workorder/remove-from-priority/`,
        { workorder_detail_ids: [id] },
        { headers: authHeader() }
    );
};

const getPriorityListById = (id) => {
    return axios.get(API_URL + '/api/' + API_VERSION + `/planning/get-priority-items/?workorder_detail_id=${id}`, {
        headers: authHeader()
    });
};

const getArchivePlanningList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/planning/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
        }
    });
};

const addPlanning = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/planning/`,
        formData, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};

const getPlanningById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/planning/${id}/`, {
        headers: authHeader()
    });
};

const getAgeingOptions = (temperId, alloyId) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/aging-cycle/', {
        headers: authHeader(), params: {
            alloy_id: temperId,
            temper_id: alloyId,
        }
    });
};

const updatePlanning = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/planning/${id}/`, // Include the die group's ID in the URL
        formPayload, // Payload for the request body
        { headers: authHeader() }, // Authentication header
    );
};

const archivePlanning = (id) => {
    return axios.delete(
        `${API_URL}/api/${API_VERSION}/planning/${id}/`,
        { headers: authHeader() } // Authentication header
    );
};

const unArchivePlanning = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/planning/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const alloyService = {
    getPlanningList,
    getPlanningListByField,
    getArchivePlanningList,
    addPlanning,
    getPlanningById,
    getPriorityListById,
    getPriorityList,
    updatePlanning,
    removePriority,
    archivePlanning,
    unArchivePlanning,
    getAgeingOptions,
};

export default alloyService;
